// src/utils/avatar.js
// Avatar çözümleme — kullanıcının map/marker görselini belirler.
//
// Kullanıcı kararı (Snap tarzı): GERÇEK PROFİL FOTOĞRAFI DEĞİL, avatar kullan.
//  1) Kişi AvatarModal'dan avatar seçtiyse → onun seçtiği avatar (avatarUrl).
//  2) Seçmediyse → CİNSİYETE göre standart avatar (kadın→kadın, erkek→erkek).
//  3) Cinsiyet de yoksa → tek genel varsayılan.
//
// Avatarlar /public/avatars/avatar 1-9.png (160px'e sıkıştırıldı, ~5KB).

export const DEFAULT_AVATAR_MALE = "/avatars/avatar 1.png"; // erkek standart
export const DEFAULT_AVATAR_FEMALE = "/avatars/avatar 2.png"; // kadın standart
export const DEFAULT_AVATAR_NEUTRAL = "/avatars/default.svg"; // cinsiyet bilinmiyor

const FEMALE_HINTS = ["kadın", "kadin", "kız", "kiz", "female", "woman", "k", "f"];
const MALE_HINTS = ["erkek", "male", "man", "e", "m"];

export function isFemale(cinsiyet?: unknown) {
  if (!cinsiyet) return false;
  return FEMALE_HINTS.includes(String(cinsiyet).trim().toLowerCase());
}

export function isMale(cinsiyet?: unknown) {
  if (!cinsiyet) return false;
  return MALE_HINTS.includes(String(cinsiyet).trim().toLowerCase());
}

// FIX (P0): cinsiyet kadın→kadın, erkek→erkek, BİLİNMİYOR→nötr (eskiden bilinmeyen
// herkese erkek atanıyordu → kadın kullanıcı erkek avatar görüyordu).
export function genderDefaultAvatar(cinsiyet?: unknown) {
  if (isFemale(cinsiyet)) return DEFAULT_AVATAR_FEMALE;
  if (isMale(cinsiyet)) return DEFAULT_AVATAR_MALE;
  return DEFAULT_AVATAR_NEUTRAL;
}

/**
 * Bir kullanıcı dokümanından (users) map avatarını çöz.
 * @param {{avatarUrl?:string, cinsiyet?:string}} user
 */
export function resolveAvatar(user: { avatarUrl?: string; cinsiyet?: string } = {}) {
  if (user && user.avatarUrl) return user.avatarUrl;
  return genderDefaultAvatar(user && user.cinsiyet);
}

// ── <img onError> GÜVENLİ DÜŞÜŞ ───────────────────────────────────────────
//
// 🔴 NEDEN SAF BİR KARAR FONKSİYONU (2026-08-22, ölçülerek):
// Kod tabanında `onError={(e) => { e.currentTarget.src = X }}` deseni üç yerde
// vardı ve üçü de İKİ ayrı hataya açıktı:
//
//  1. SONSUZ DÖNGÜ — düşülen adres de yüklenemezse `onerror` yeniden ateşler,
//     aynı adres yeniden istenir, döngü kapanmaz. `BlockedUsers.tsx` tam bunu
//     yapıyordu: hata veren adresi AYNI adrese atıyordu. Sanal dünya kaydında
//     ölçüldü — aynı tohumun iki koşusunda 170'e karşı 186 kesilen istek; tek
//     başına 5 kayıt alanını kaydırıyordu. Bu yüzden `onerror = null`,
//     atamadan ÖNCE gelir.
//
//  2. KENDİNE DÜŞME — hata veren adres ZATEN varsayılansa yeniden atamak
//     anlamsızdır ve tarayıcıya aynı başarısız isteği tekrarlatır.
//
// ⚠️ İNCELİK (testin yakaladığı): `img.src` okunduğunda MUTLAK adres döner
// (`http://host/avatars/default.svg`), yazılan göreli değer değil. Bu yüzden
// karşılaştırma `===` ile literal üzerinden YAPILAMAZ; yol (pathname)
// üzerinden yapılır. Bu ayrımı kaçıran bir guard sessizce hiç çalışmaz.

/** Bir adresin yol (pathname) kısmı — origin ve sorgu atılır. */
function yolu(adres: string): string {
  const s = String(adres || "");
  if (!s) return "";
  // `new URL` göreli adreste taban ister; taban sabit ve yalnız ayrıştırma için.
  try {
    return new URL(s, "http://y").pathname;
  } catch {
    return s.split("?")[0].split("#")[0];
  }
}

/**
 * Yüklenemeyen bir avatar adresi için düşüş kararı. SAF — DOM'a dokunmaz.
 * @param mevcutSrc hata veren `<img>`in adresi (mutlak veya göreli)
 */
export function avatarDusumKarari(
  mevcutSrc: string,
): { dus: boolean; hedef: string } {
  const yol = yolu(mevcutSrc);
  // Zaten varsayılandaysa DÜŞME: tekrar atamak aynı başarısız isteği yeniler.
  if (yol === DEFAULT_AVATAR_NEUTRAL) return { dus: false, hedef: DEFAULT_AVATAR_NEUTRAL };
  return { dus: true, hedef: DEFAULT_AVATAR_NEUTRAL };
}

/**
 * `<img onError={avatarHatasi}>` — tek satırlık güvenli düşüş.
 * Önce `onerror`u söker (döngü kapısı), sonra gerekiyorsa varsayılana düşer.
 */
export function avatarHatasi(e: { currentTarget: HTMLImageElement }): void {
  const img = e && e.currentTarget;
  if (!img) return;
  // ÖNCE söküm: aşağıdaki atama da hata verirse döngü başlamasın.
  img.onerror = null;
  const karar = avatarDusumKarari(img.src);
  if (karar.dus) img.src = karar.hedef;
}
